import { NavConfig } from '../components/global-nav/configs/base'
import { UserInformation } from '../components/global-nav/user-info/user-info'
import { FinalAuthConfig } from '../config/auth-config'
import { createPortableExperiences, PortableExperiences } from './portable-experiences'

export function initializeGbpe(
	authConfig: FinalAuthConfig,
	userInfo: UserInformation,
	config: NavConfig,
	portableExperiencesObject: PortableExperiences
) {
	if (window.gbpe) {
		console.warn('gbpe already defined, updating gbpe services')
		window.gbpe.auth = portableExperiencesObject.auth ?? window.gbpe.auth
		const existingLanguageService = window.gbpe.languageService
		const incomingLanguageService = portableExperiencesObject.languageService
		window.gbpe.languageService =
			existingLanguageService?.isInitialized && incomingLanguageService
				? existingLanguageService
				: incomingLanguageService ?? existingLanguageService
		window.gbpe.overlay = portableExperiencesObject.overlay ?? window.gbpe.overlay
		window.gbpe.regionService = portableExperiencesObject.regionService ?? window.gbpe.regionService
		window.gbpe.config = authConfig ?? window.gbpe.config
		window.gbpe.user = userInfo ?? window.gbpe.user
		window.gbpe.entitlementService = portableExperiencesObject.entitlementService ?? window.gbpe.entitlementService
		window.gbpe.authContentService = portableExperiencesObject.authContentService ?? window.gbpe.authContentService
	} else {
		window.gbpe = createPortableExperiences(
			authConfig,
			userInfo,
			portableExperiencesObject?.auth,
			portableExperiencesObject?.overlay,
			config?.urls,
			portableExperiencesObject?.entitlementService,
			portableExperiencesObject?.authContentService
		)
		window.gbpe.finalize()
	}
}
